import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import ExportDocumentationPage from "../pages/export-documentation/page";
import QualityAssurancePage from "../pages/quality-assurance/page";
import LogisticsSupportPage from "../pages/logistics-support/page";
import CustomsClearancePage from "../pages/customs-clearance/page";
import { useEffect } from "react";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

function withScrollToTop(Component: React.ComponentType) {
  return function WrappedComponent() {
    return (
      <>
        <ScrollToTop />
        <div className="page-transition">
          <Component />
        </div>
      </>
    );
  };
}

const routes: RouteObject[] = [
  {
    path: "/",
    Component: withScrollToTop(Home),
  },
  {
    path: "/products",
    Component: withScrollToTop(ProductsPage),
  },
  {
    path: "/services",
    Component: withScrollToTop(ServicesPage),
  },
  {
    path: "/about",
    Component: withScrollToTop(AboutPage),
  },
  {
    path: "/contact",
    Component: withScrollToTop(ContactPage),
  },
  {
    path: "/export-documentation",
    Component: withScrollToTop(ExportDocumentationPage),
  },
  {
    path: "/quality-assurance",
    Component: withScrollToTop(QualityAssurancePage),
  },
  {
    path: "/logistics-support",
    Component: withScrollToTop(LogisticsSupportPage),
  },
  {
    path: "/customs-clearance",
    Component: withScrollToTop(CustomsClearancePage),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
